"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contentGrid = void 0;
exports.contentGrid = {
    start: [1, null, null, 2],
    end: [13, null, null, 12],
};
